// Admin pending-review queue: public suggestions waiting for approval.
import { api, ApiError } from './api';
import { loadPayload, refreshPendingCount } from './data';
import { $, el } from './dom';
import { fmtMs } from './format';
import { gotoFrameMs } from './frames';
import { state } from './state';
import { closeAllDialogs } from './termsUi';
import { toast } from './toast';

export function initPendingDialog(): void {
  $('#btnPending').addEventListener('click', () => {
    $<HTMLDialogElement>('#pendingDialog').showModal();
    void renderPending();
  });
}

async function renderPending(): Promise<void> {
  const list = $('#pendingList');
  let items;
  try {
    items = await api.admin.pending();
  } catch (err) {
    toast(err instanceof ApiError ? err.message : 'failed to load pending items', 'err');
    return;
  }
  list.textContent = '';
  if (items.length === 0) {
    list.appendChild(el('li', 'dim', 'Nothing pending — all caught up.'));
    return;
  }
  for (const item of items) {
    const li = el('li');
    li.appendChild(el('span', '', item.term_text));
    if (item.term_status === 'pending') {
      const chip = el('span', 'chip new', 'new term');
      chip.title = 'This term does not exist yet; approving creates it.';
      li.appendChild(chip);
    }
    const jump = el('button', 'jump', `${fmtMs(item.frame_ms)} · polygon #${item.polygon_id}`);
    jump.title = 'Jump to this polygon';
    jump.addEventListener('click', () => {
      closeAllDialogs();
      state.selectedPolygonId = item.polygon_id;
      gotoFrameMs(item.frame_ms);
    });
    li.appendChild(jump);

    const actions = el('span', 'row-actions');
    const approve = el('button', 'accent-btn', 'approve');
    approve.addEventListener('click', () => void act(() => api.admin.approve(item.connection_id)));
    const reject = el('button', 'ghost danger', 'reject');
    reject.addEventListener('click', () => void act(() => api.admin.reject(item.connection_id)));
    actions.append(approve, reject);
    li.appendChild(actions);
    list.appendChild(li);
  }
}

async function act(fn: () => Promise<unknown>): Promise<void> {
  try {
    await fn();
    await renderPending();
    void refreshPendingCount();
    void loadPayload();
  } catch (err) {
    toast(err instanceof ApiError ? err.message : 'action failed', 'err');
  }
}
